import React, { useContext } from "react";

import { useTranslation } from "react-i18next";

import TeamIcon from "@components/icons/TeamIcon";
import { EventContext, LookupContext } from "@gp/components";
import { EventKeyBettingOffer } from "@gp/models";
import { EventKeyOffer } from "@gp/offer";
import { toDisplayOdd } from "@gp/utility";
import { useRootAppStore } from "@hooks";
import classNames from "classnames";
import { observer } from "mobx-react";

export const EventOutrightOfferRowItem = observer(
	function EventOutrightOfferRowItem(props: {
		tip: EventKeyBettingOffer;
		isSelected: boolean;
		eventKey: EventKeyOffer;
	}) {
		const { t } = useTranslation();
		const event = useContext(EventContext);
		const lookupsStore = useContext(LookupContext);

		const rootStore = useRootAppStore();

		const team = props.tip?.teamId
			? lookupsStore?.teams?.get(props.tip.teamId)
			: undefined;
		const tournament = lookupsStore?.tournaments?.get(event?.tournamentId);

		const betSlipStore = rootStore.betSlipStore;

		const displayTipValue = toDisplayOdd(props.tip.value);

		if (displayTipValue == null) {
			return null;
		}

		const btnClasses = classNames("quote", "quote--button", {
			"one-click": betSlipStore.isOneClickBetActive,
			"is-active": props.isSelected,
			desc: props.tip.indicator === -1,
			inc: props.tip.indicator === 1,
		});

		return (
			<div key={props.tip.id} className="offer__outright__item">
				<div className="offer__outright__inner" title={props.tip.tip}>
					<TeamIcon
						showCountryFlag={tournament?.showCountryFlag}
						flagCode={team?.countryCode}
						jerseyTypeAbrv={team?.jerseyTypeAbrv}
						className="offer__outright__flag u-icon--base"
					/>
					<span className="offer__outright__tip">
						{props.tip.tip}{" "}
						{props.tip.gender === 1 ? (
							<>({t<string>("OFFER.GENDER.WOMEN")})</>
						) : null}
					</span>
				</div>
				<button
					type="button"
					className={btnClasses}
					title={displayTipValue}
					disabled={
						props.tip.isLocked ||
						event.isLocked ||
						props.eventKey.isLocked
					}
					onClick={() => betSlipStore.addRemoveOffer(props.tip)}
				>
					{displayTipValue}
				</button>
			</div>
		);
	}
);
